import { styled } from "@mui/material/styles"

import { Chip as UiChip, ChipSkeleton as UiChipSkeleton } from "../Chip"
import { ChipAdd as L2rChipAdd } from "../ChipAdd"

const ICON_SMALL = 24


export const Chip = styled(UiChip, {
    shouldForwardProp: (prop) => prop !== "small",
})(({ color, small, theme, variant }) => ({
    borderColor: theme.palette[color].main,
    margin: theme.spacing(1),
    padding: theme.spacing(small ? 0 : 4, 1),
    height: small && ICON_SMALL,

    "& .MuiChip-deleteIcon": {
        color: variant === "outlined" && theme.palette["cta-bg/cta-bg-primary"].main,
        width: small && 13,
        height: small && 13,
    },
}))

export const ChipSkeletonsWrapper = styled("div")({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
})

export const ChipSkeleton = styled(UiChipSkeleton)(({ theme }) => ({
    margin: theme.spacing(1),
}))

export const ChipAdd = styled(L2rChipAdd)(({ small, theme }) => ({
    margin: theme.spacing(0, 1),
    height: small && ICON_SMALL,
    width: small && ICON_SMALL,

    "& > *": {
        width: small && 18,
        height: small && 18,
    },
}))

export const ChipsWrapper = styled("div")({
    alignItems: "center",
    display: "flex",
    flexWrap: "wrap",
})